import React, { useEffect } from 'react'
import { PieChart } from 'react-minimal-pie-chart'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from '../../../store/rootReducer'
import { AuthStateProps } from '../../../interfaces/auth'
import { getUserStatistics } from '../../../store/actions/reports'

export default function Reports() {
  const dispatch = useDispatch()

  const chartColor = ['#FF9F0A', '#dd474aff', '#124E7F', '#467D20', '#A259FF']

  const { token } = useSelector<AppState, Partial<AuthStateProps>>(
    ({ auth: { authorizedOrganizations, options, token } }) => ({
      authorizedOrganizations,
      options,
      token,
    })
  )

  useEffect(() => {
    dispatch(getUserStatistics({ token: token || '' }))
  }, [dispatch])

  const userStatistics = useSelector(
    (state: AppState) => state.reports.userStatistics
  )

  return (
    <div>
      <h2 style={{ paddingLeft: '40px', paddingTop: '20px', fontSize: '32px' }}>
        User Statistics
      </h2>
      <div style={{ display: 'flex', gap: '40px', alignItems: 'center' }}>
        <div style={{ width: '300px', height: '300px', position: 'relative' }}>
          <PieChart
            data={
              userStatistics?.roleTotals?.map((item, index) => ({
                title: String(item.role),
                value: Number(item.totalUsers),
                color: chartColor[index % chartColor.length],
              })) || []
            }
            radius={35}
            labelPosition={112}
            lineWidth={20}
          />
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
            }}
          >
            <div style={{ fontSize: '32px', fontWeight: 'bold' }}>
              {userStatistics?.userTotal}
            </div>
            <div style={{ fontSize: '18px', color: '#666666' }}>
              Total Users
            </div>
          </div>
        </div>
        <ul>
          {userStatistics?.roleTotals?.map((item, index) => (
            <li
              key={String(item.role)}
              style={{
                fontSize: '16px',
                marginBottom: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span
                style={{
                  width: '15px',
                  height: '15px',
                  backgroundColor: chartColor[index % chartColor.length],
                  borderRadius: '2px',
                  display: 'inline-block',
                }}
              />
              {item.role}: {item.totalUsers.toLocaleString()}
            </li>
          )) || []}
        </ul>
      </div>
    </div>
  )
}
